import { EmptyButton } from 'mol-ui';
import styled from 'styled-components';
import {
    Row as BoostrapRow,
    Col
} from 'reactstrap';

export const Avatar = styled.img`
    border-radius: 100%;
    height: 100px;
    object-fit: cover;
    width: 100px;
`;

export const ButtonsContainer = styled(Col)`
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 20px;
    justify-content: center;
    margin-top: 20px;
    width: 100%;
`;

export const DropContainer = styled.div`
    align-items: center;
    border: 1px dashed ${ ({ theme: { textColor } }) => textColor };
    border-radius: 10px;
    color: ${ ({ theme: { textColor } }) => textColor };
    cursor: copy;
    display: flex;
    font-size: 12px;
    font-style: italic;
    height: 100px;
    margin: 20px 0px 10px 0px;
    justify-content: center;
    outline: unset;
    text-align: center;
    width: 100%;

    :focus,
    :focus-within {
        border: unset;
        box-shadow: 0px 0px 1px 1px ${ ({ theme: { primaryColor } }) => primaryColor };
    }
`;

export const ErrorMessage = styled.p`
    color: ${ ({ theme: { errorColor } }) => errorColor };
    font-family: 'Montserrat', sans-serif;
    font-size: .8rem;
    margin: 5px 10px;
    position: absolute;
    top: 80px;
`;

export const ImagePreview = styled.img`
    max-height: 200px;
    max-width: 200px;
    object-fit: cover;
`;

export const ProfileContainer = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-bottom: 20px;
    width: 100%;
`;

export const ProfileText = styled(EmptyButton)`
    all: unset;
    color: ${ ({ theme: { textColor } }) => textColor };    
    cursor: pointer;
    margin-top: 10px;
`;

export const ProfileIcon = styled.div`
    background: ${ ({ theme: { darkGray } }) => darkGray };
    border-radius: 100%;
    cursor: pointer;
    align-items: center;
    display: flex;
    height: 100px;
    justify-content: center;
    margin-bottom: 5px;
    width: 100px;
`;

export const StyledCol = styled(Col)`
    margin-top: ${ ({ margin }) => margin || '40px' };
`;

export const InputHidden = styled.input`
    display: none;
`;

export const ResponsiveCol = styled(Col)`
    @media (max-width: ${ ({ breakpoint }) => breakpoint ?? '767px' }) {
        align-items: center;
        display: flex;
        justify-content: center;
        margin: -10px 0px 10px -10px;
    }
`;

export const StyledRow = styled(BoostrapRow)`
    margin-bottom: 20px;
`;
